import { render, staticRenderFns } from "./NotesLandingCourse.vue?vue&type=template&id=0bf74360&scoped=true&"
import script from "@/scripts/Notes/NotesLanding/components/NotesLandingCourse.js?vue&type=script&lang=js&"
export * from "@/scripts/Notes/NotesLanding/components/NotesLandingCourse.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf74360",
  null
  
)

export default component.exports